import React, { useRef } from 'react';
import { useGLTF, OrbitControls, Stage } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';

export const ChairModel = () => {
  const { scene } = useGLTF('/assets/chair-model.glb');
  
  return (
    <Canvas shadows dpr={[1, 2]} camera={{ position: [0, 0, 1.5], fov: 50 }}>
      <Stage environment="city" intensity={0.6} adjustCamera={false}>
        <primitive object={scene} />
      </Stage>
      <OrbitControls 
        autoRotate 
        autoRotateSpeed={1.0} 
        enableZoom={true} 
        minDistance={1.0}
        maxDistance={10}
      />
    </Canvas>
  );
};
